import { Outlet, useRouterState } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { NamespaceBoundary } from '@/lib/i18n/NamespaceBoundary';
import { MobileAccessNotice } from './MobileAccessNotice';
import { isMobileBrowser, isGuestPublicPath } from './mobile-access';

export function RootWebView() {
  const path = useRouterState({ select: (state) => state.location.pathname });
  if (isMobileBrowser() && !isGuestPublicPath(path)) {
    return <NamespaceBoundary namespace="shell"><MobileAccessNotice /></NamespaceBoundary>;
  }
  return <>
    <Outlet />
    {import.meta.env.DEV && <TanStackRouterDevtools />}
  </>;
}
